import { useEffect } from "react";
import { Menu, MenuItem, ProSidebar } from "react-pro-sidebar";

import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import {
  Box,
  IconButton,
  Stack,
  Typography,
  useTheme,
  Button,
  Tooltip,
  Drawer,
} from "@mui/material";

import MessageManager from "../../components/utils/MessageManager";
import { useApp } from "../../hooks/useApp";
import { tokens } from "../../theme";
import { CONSTANT } from "../../utils/Constant";

import "react-pro-sidebar/dist/css/styles.css";
import { useSidebarData } from "./SidebarDataContext";
import {
  LogoutIcon,
  CloudDoneIcon,
  CloudOffIcon,
} from "../../components/svgicons/SvgIcons";

import SidebarMenu from "./SidebarMenu";

const SidebarMenuWrap = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const {
    errorMsg,
    successMsg,
    resetErrorMsg,
    resetSuccessMsg,
    authInfo,
    logoutProvider,
  } = useApp();

  const {
    isCollapsed,
    setIsCollapsed,
    newMessageClient,
    newMessageLead,
    hasNewEmail,
    webSocketActive,
    toggled,
    setToggled,
    broken,
    setBroken,
  } = useSidebarData();

  const handleLogout = () => {
    // Lógica para cerrar sesión
    logoutProvider();
  };

  useEffect(() => {
    const handleResize = () => {
      setBroken(window.innerWidth < 769);
      setIsCollapsed(window.innerWidth < 769 ? false : isCollapsed);
    };

    // Agrega el listener del evento 'resize' al objeto window
    window.addEventListener("resize", handleResize);
    handleResize();

    // Esta función se ejecuta cuando el componente se desmonta
    // Es importante remover el listener para evitar fugas de memoria
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <Box
        sx={{
          "& .pro-sidebar": {
            color: `${colors.primary[500]} !important`,
            fontWeight: `bold  !important`,
            width: isCollapsed ? "60px" : "240px", // Cambiar el ancho según el estado
            minWidth: isCollapsed ? "60px" : "240px", // Cambiar el ancho según el estado
            transition: "width 0.3s ease-in-out", // Transición suave
            [theme.breakpoints.down("sm")]: {
              // Media query usando breakpoints de Material UI
              width: "100%!important",
            },
          },
          "& .pro-sidebar-inner": {
            background: `${colors.primary[450]} !important`,
          },
          "& .pro-icon-wrapper": {
            backgroundColor: "transparent !important",
            fontWeight: "bold !important",
            marginTop: "-10px",
            marginRight: "-25px!important",
          },
          "& .pro-inner-item:hover": {
            color: `${colors.primary[500]} !important`,
          },
          "& .pro-menu-item.active": {
            color: "#ffffff !important",
          },
          "& .pro-inner-item": {
            flexDirection: "column",
            alignItems: "flex-end!important",
          },
          "& .pro-item-content": {
            opacity: isCollapsed ? 0 : 1,
            height: isCollapsed ? "0px" : "auto",
            width: isCollapsed ? "0px" : "100%",
          },
          "& .pro-sidebar.md:not(.toggled):not(.collapsed)": {
            left: "-100%",
            [theme.breakpoints.up("sm")]: {
              // Media query usando breakpoints de Material UI
              left: "-320px",
            },
            [theme.breakpoints.up("tablet")]: {
              // Media query usando breakpoints de Material UI
              left: "0px",
            },
          },
        }}
      >
        <ProSidebar
          collapsed={broken ? false : isCollapsed}
          toggled={toggled}
          onBreakPoint={() => setBroken(!broken)}
          //onBackdropClick={() => setToggled(false)}
          breakPoint="md"
          width="320px"
        >
          <Stack
            direction="column"
            justifyContent="space-between"
            minHeight="100%"
            spacing={2}
          >
            <Menu iconShape="square">
              <MenuItem
                onClick={() =>
                  broken ? setToggled(!toggled) : setIsCollapsed(!isCollapsed)
                }
                icon={<MenuOutlinedIcon />}
                style={{
                  margin: "10px 0 20px 0",
                  color: colors.grey[100],
                }}
              >
                {/* {!isCollapsed && ( */}
                <>
                  <Box
                    position="relative" // Hacer que el contenedor del logo sea el referente para la posición absoluta del ícono
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    ml="15px"
                    mt="20px"
                  >
                    {/* Logo de Bitcode */}
                    <Box
                      display="flex"
                      backgroundColor="#ffffff"
                      borderRadius="3px"
                    >
                      <img
                        src="https://bitcode-enterprise.com/wp-content/uploads/2023/08/bitcode_logo_final.webp"
                        alt="companylogo"
                        width="200"
                      />
                    </Box>
                  </Box>

                  {/* Texto CRM debajo del logo */}
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    marginTop="20px"
                    marginBottom="20px"
                  >
                    <Typography
                      variant="h2"
                      fontWeight="bold"
                      color={colors.primary[500]}
                    >
                      CRM
                    </Typography>
                  </Box>
                </>
                {/*    )} */}
              </MenuItem>

              {/* {!isCollapsed && ( */}
              <Box
                paddingLeft={isCollapsed ? undefined : "10%"}
                onClick={() => isCollapsed && setIsCollapsed(!isCollapsed)}
                sx={{
                  "& ul *": {
                    pointerEvents: isCollapsed ? "none" : "all",
                  },
                }}
              >
                <SidebarMenu
                  rol={authInfo?.userRole?.id}
                  alertClient={newMessageClient}
                  alertLead={newMessageLead}
                  alertEmail={hasNewEmail}
                />
              </Box>
              {/* )} */}
            </Menu>
            <Stack direction="column" alignItems="center">
              {!isCollapsed && (
                <>
                  <Stack
                    display="flex"
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    marginBottom="20px"
                  >
                    {webSocketActive ? (
                      <Tooltip title={CONSTANT.LABEL_WEBSOCKET_ACTIVE}>
                        <div>
                          <CloudDoneIcon
                            sx={{ width: 25, color: colors.green[500] }}
                          />
                        </div>
                      </Tooltip>
                    ) : (
                      <Tooltip title={CONSTANT.LABEL_WEBSOCKET_DESACTIVE}>
                        <div>
                          <CloudOffIcon
                            sx={{ width: 25, color: colors.red[500] }}
                          />
                        </div>
                      </Tooltip>
                    )}
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      color={colors.primary[500]}
                    >
                      {authInfo.name}
                    </Typography>
                    <Typography
                      variant="h5"
                      color={colors.primary[500]}
                      align="center"
                    >
                      {authInfo.username}
                    </Typography>
                  </Stack>

                  <Stack
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    marginBottom="40px"
                  >
                    <Tooltip title="Cerrar sesión">
                      <Button
                        variant="contained"
                        color="grey"
                        onClick={handleLogout}
                        sx={{
                          width: "40px !important",
                          minWidth: "40px !important",
                          maxWidth: "40px !important",
                          height: "40px !important",
                          minWheight: "40px !important",
                          maxWheight: "40px !important",
                        }}
                      >
                        <LogoutIcon
                          sx={{ width: 25, color: colors.primary[500] }}
                        />
                      </Button>
                    </Tooltip>
                  </Stack>
                  <Stack>
                    {/* Espacio en blanco para que respete el margin bottom del objecto de arriba */}
                  </Stack>
                </>
              )}
              {isCollapsed && (
                <>
                  <Stack
                    display="flex"
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    marginBottom="20px"
                  ></Stack>

                  <Stack
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    marginBottom="40px"
                  >
                    <Tooltip title="Cerrar sesión">
                      <Button
                        variant="contained"
                        color="grey"
                        onClick={handleLogout}
                        sx={{
                          width: "40px !important",
                          minWidth: "40px !important",
                          maxWidth: "40px !important",
                          height: "40px !important",
                          minWheight: "40px !important",
                          maxWheight: "40px !important",
                        }}
                      >
                        <LogoutIcon
                          sx={{ width: 25, color: colors.primary[500] }}
                        />
                      </Button>
                    </Tooltip>
                  </Stack>
                  <Stack>
                    {/* Espacio en blanco para que respete el margin bottom del objecto de arriba */}
                  </Stack>
                </>
              )}
            </Stack>
          </Stack>
        </ProSidebar>
      </Box>
      {errorMsg && (
        <MessageManager
          type={CONSTANT.ERROR_MSG}
          msg={errorMsg}
          details=""
          callback={resetErrorMsg}
        />
      )}
      {successMsg && (
        <MessageManager
          type={CONSTANT.SUCCESS_MSG}
          msg={successMsg}
          details=""
          callback={resetSuccessMsg}
        />
      )}
    </>
  );
};

export default SidebarMenuWrap;
